import React, { useEffect, useRef, useState } from "react";
import store from "src/Reducers/store";
import { useSelector } from "react-redux";
import "./EntryEffect.css";

interface EntryEffectProps {
  pageNumber: number;
  entryDelay?: number;
  entryStyle?: React.CSSProperties;
  children: React.ReactNode;
}

const EntryEffect = ({
  children,
  pageNumber,
  entryDelay = 1000,
  entryStyle = {},
}: EntryEffectProps) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const currentPage = useSelector(
    () => store.getState().appReducer.currentPage,
  );
  const entryElements =
    containerRef.current?.querySelectorAll(".entry-element") || [];

  const [adjustedTimes, setAdjustedTimes] = useState<number[]>([]);

  useEffect(() => {
    const adjustTimes = () => {
      const newTimes: number[] = [];
      let delay = 0;
      React.Children.forEach(children, (_, index) => {
        if (index === 0) {
          newTimes.push(entryDelay);
        } else {
          delay += entryDelay;
          newTimes.push(delay);
        }
      });
      return newTimes;
    };

    setAdjustedTimes(adjustTimes());
  }, [children, entryDelay]);

  useEffect(() => {
    entryElements.forEach((entryElement, index) => {
      entryElement.classList.remove("animate-entry");
    });
    if (pageNumber === currentPage) {
      startEffect();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageNumber, currentPage]);

  const startEffect = () => {
    entryElements.forEach((entryElement, index) => {
      setTimeout(
        () => entryElement.classList.add("animate-entry"),
        adjustedTimes.slice(0, index + 1).reduce((sum, num) => sum + num, 0),
      );
    });

    if (containerRef.current) {
      containerRef.current.scrollTop = containerRef.current.scrollHeight;
    }
  };

  return (
    <div className="entry-container" style={entryStyle} ref={containerRef}>
      {React.Children.map(children, (child, index) => (
        <div key={index} className={"entry-element"}>
          {child}
        </div>
      ))}
    </div>
  );
};

export default EntryEffect;
